export default "__VITE_ASSET__6d14ef07__"